import {FC} from 'react';
import {Upload} from 'antd';
import type {RcFile, UploadFile, UploadListType, UploadProps,} from 'antd/es/upload/interface';
import type {UploadRequestOption} from 'rc-upload/lib/interface';
import UploadBtn from '../upload-btn';
import {getBase64, validateFile} from '@/utils';

interface ImageCropperProps {
  maxImagesCount: number;
  fileList: UploadFile[];
  listType?: UploadListType;
  fileTypes?: string[];
  maxSizeInMB?: number;
  onChangeFileList: (fileList: UploadFile<any>[]) => void;
  onRemoveImage?: (fileId: string) => void;
  isLoading?: boolean;
  onUploadFile?: (file: string) => void;
}

const Uploader: FC<ImageCropperProps> = ({
                                           maxImagesCount = 1,
                                           fileList = [],
                                           listType = 'picture-card',
                                           fileTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'],

                                           maxSizeInMB,
                                           onChangeFileList = () => {
                                           },
                                           onRemoveImage = () => {
                                           },
                                           onUploadFile = () => {
                                           },
                                           isLoading = false,
                                         }) => {
  const readFile = async (file: UploadFile | RcFile | Blob | string) =>
    await new Promise<string>(resolve => {
      const reader = new FileReader();
      if (typeof file === 'object' && 'originFileObj' in file) {
        reader.readAsDataURL(file.originFileObj as RcFile);
      } else {
        reader.readAsDataURL(file as RcFile);
      }

      reader.onload = () => resolve(reader.result as string);
    });

  const uploadRequest = async ({onSuccess}: UploadRequestOption) => {
    onSuccess?.('ok');
  };

  // handle remove image
  const onRemove = (file: UploadFile<any>) => {
    if (onRemoveImage) {
      onRemoveImage(file.uid);
    }
  };

  // handle image change
  const onChange: UploadProps['onChange'] = info => {
    if (info.file.status === 'done') {
      getBase64(info.file.originFileObj as RcFile, base64File => {
        if (onUploadFile) {
          onUploadFile(base64File as string);
        }
      });
    }
    onChangeFileList(info.fileList);
  };

  // handle before uploading

  const beforeUpload = (file: RcFile) =>
    validateFile(file, fileTypes as string[], maxSizeInMB as number) ||
    Upload.LIST_IGNORE;

  // handle image preview
  // handle image preview
  const onPreview = async (file: UploadFile) => {
    let src = file.url as string;
    if (!src) {
      src = await readFile(file);
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  return (
    <Upload
      customRequest={uploadRequest}
      listType={listType}
      defaultFileList={[...fileList]}
      fileList={[...fileList]}
      onChange={onChange}
      onPreview={onPreview}
      beforeUpload={beforeUpload}
      onRemove={onRemove}
      accept={fileTypes?.join()}
    >
      {fileList.length < maxImagesCount && <UploadBtn loading={isLoading}/>}
    </Upload>
  );
};

export default Uploader;
